import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import styled from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IconButtonWrapper = styled.div.withConfig({
  displayName: "CollapsiblePanelHeader__IconButtonWrapper"
})(["display:flex;align-items:center;justify-content:center;overflow:hidden;width:", ";opacity:", ";transform:", ";margin-inline-end:0;pointer-events:", ";transition:width 0.2s ease,opacity 0.2s ease,transform 0.2s ease,margin-inline-end 0.2s ease;"], ({
  $isCollapsed,
  theme
}) => $isCollapsed ? theme.space['800'] : '0', ({
  $isCollapsed
}) => $isCollapsed ? 1 : 0, ({
  $isCollapsed
}) => $isCollapsed ? 'translateX(0)' : 'translateX(-8px)', ({
  $isCollapsed
}) => $isCollapsed ? 'auto' : 'none');
export const CollapsiblePanelHeader = ({
  isCollapsed,
  onToggle,
  ariaLabel,
  tooltip,
  icon,
  title
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: isCollapsed ? 'center' : 'start',
    alignItems: "center",
    gap: "0",
    marginBlockEnd: "400",
    paddingInline: isCollapsed ? '400' : '500',
    paddingBlockStart: "400",
    children: [/*#__PURE__*/_jsx(IconButtonWrapper, {
      $isCollapsed: isCollapsed,
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: onToggle,
        onMouseUp: event => event.currentTarget.blur(),
        tooltip: tooltip,
        "aria-label": ariaLabel,
        "aria-expanded": !isCollapsed,
        use: "unstyled",
        children: icon
      })
    }), !isCollapsed && /*#__PURE__*/_jsx(Text, {
      as: "h2",
      color: "text-core-default",
      typography: "heading-300",
      children: title
    })]
  });
};